import $ from 'jquery'
import 'browser-identify'
import 'detect-input-method'
import moment from 'moment'
import 'slick-carousel'

// Test and set visited flag (cookie bar)
if(!localStorage.getItem('Heron.visited')) {
  $('#cookie-bar').removeClass('hidden')
}
localStorage.setItem('Heron.visited', 'true')

// Slick carousel
$('.module--carousel > .inner').each(function() {
  const $this       = $(this),
        frameCount  = $('.carousel__frame', this).length

  $this.slick({
    dots:       frameCount > 1,
    arrows:     false
  })
})

// Header scroll
$(window).on('scroll', () => {
  const scrollY = $(window).scrollTop()

  $('html').toggleClass('scrolledToTop', scrollY == 0)
}).trigger('scroll')

// Form focus
$('input, textarea, select').on('focus',
  event => $(event.target).closest('label').addClass('has-focus')
).on('blur',
  event => $(event.target).closest('label').removeClass('has-focus')
)

// Wrap selects
$('select').wrap('<div class="select__wrapper" />')

// Mobile avigation
$('.menu-toggle').on('click', () => $('html').toggleClass('menuVisible'))
$('.header__overlay')
  .on('mousewheel touchmove gesturemove', event => event.preventDefault())
  .on('click', event => $('html').removeClass('menuVisible'))

// Horizontal scroll
$('.module--rounded-list .rounded__slider').on('scroll', function() {
  const $this           = $(this),
        $module         = $this.closest('.module'),
        containerWidth  = $module.find('.rounded__slider__wrapper').innerWidth(),
        listWidth       = $module.find('ul')[0].scrollWidth,
        scrollLeft      = $this.scrollLeft()

  $module
    .toggleClass('scrolledToLeft',  scrollLeft == 0)
    .toggleClass('scrolledToRight', scrollLeft + containerWidth >= listWidth)
}).trigger('scroll')

// Form validation
$('form').on('submit', event => {
  const formData = $(event.target).formData(),
        errors   = [],
        required = [
          'name', 'surname', 'center', 'email', 'tel', 'level',
          'number', 'from_d', 'from_m', 'from_y', 'to_d', 'to_m',
          'to_y', 'legal'
        ],
        dateFrom = [formData.from_d, formData.from_m, formData.from_y].join('/'),
        dateTo   = [formData.to_d,   formData.to_m,   formData.to_y].join('/')

  // Clear errors
  $('.has-error').removeClass('has-error')

  // Required fields
  required.forEach(field => {
    if(!formData[field] || !formData[field].trim().length) {
      errors.push(field)
    }
  })

  // Email
  if(!/[a-z0-9!#$%&'*+/=?^_`{|}~.-]+@[a-z0-9-]+(\.[a-z0-9-]+)+/.test(formData.email)) {
    errors.push('email')
  }

  // Dates
  if(!moment(dateFrom, 'D/M/YYYY', true).isValid()) {
    errors.push('from_d', 'from_m', 'from_y')
  }
  if(!moment(dateTo, 'D/M/YYYY', true).isValid()) {
    errors.push('to_d', 'to_m', 'to_y')
  }

  window.Heron.updateNightCount()
  if((parseInt($('input.night-count').val()) || 0)< 1) {
    errors.push('to_d', 'to_m', 'to_y')
  }

  // Add errors
  errors.forEach(field => {
    $('[name="' + field + '"]').addClass('has-error')
  })

  if(errors.length) {
    // Scroll to highest error
    const scrollTarget = $('.has-error').first().offset().top

    $('html, body').stop().animate({
      scrollTop: scrollTarget - 100
    }, 300)
  } else {
    // Send request
    $(event.target).addClass('sending')
    $.ajax({
      type: 'POST',
      url:  '/wp-admin/admin-ajax.php',
      data: {
        action: 'estimate',
        form:   formData
      },
      success: result => {
        $(event.target).removeClass('sending')
        $('html, body').stop().animate({
          scrollTop: 0
        }, 300, () => {
          $(document.body).addClass('thank-you')
        })
      },
      error: () => {
        $(event.target).removeClass('sending')
      }
    })
  }

  event.preventDefault()
})

// Clear errors on blur
$('input, select, textarea').on('blur', function() {
  $(this).removeClass('has-error')
})

// Update night count
$('input[placeholder]').on('blur', () => window.Heron.updateNightCount())



// Functions

window.Heron.updateNightCount = () => {
  const formData = $('form').formData(),
        dateFrom = [formData.from_d, formData.from_m, formData.from_y].join('/'),
        dateTo   = [formData.to_d,   formData.to_m,   formData.to_y].join('/')

  let   nightCount

  if(moment(dateFrom, 'D/M/YYYY', true).isValid() && moment(dateTo, 'D/M/YYYY', true).isValid()) {
    nightCount = -moment(dateFrom, 'D/M/YYYY', true).diff(moment(dateTo, 'D/M/YYYY', true), 'days')
  }

  if(nightCount < 1) {
    nightCount = undefined
  }

  $('.night-count').text(nightCount || '--').val(nightCount || '--')
}



// jQuery extensions

$.fn.formData = function() {
  const output = {}

  this.serializeArray().forEach(entry => {
    if(output[entry.name]) {
      if(output[entry.name] instanceof Array) {
        output[entry.name].push(entry.value)
      } else {
        output[entry.name] = [output[entry.name], entry.value]
      }
    } else {
      output[entry.name] = entry.value
    }
  })

  return output
}